class FilterHandler {
  constructor() {
    const filterContainer = document.querySelector(".article-grid__filter")
    const filterItems = Array.from(filterContainer.children)

    const articleContainer = document.querySelector(".article-grid__container")
    const articleItems = Array.from(articleContainer.children)

    this.prev = "all"

    filterItems.forEach(item => {
      item.addEventListener("click", () => {
        const currentFilter = item.dataset.filter

        // if same filter clicked → reset to "all"
        if (this.prev === currentFilter) {
          this.articleFilter("all", articleItems)
          this.updateSelected(filterItems, "all")
          this.prev = "all"
        } else {
          this.articleFilter(currentFilter, articleItems)
          this.updateSelected(filterItems, currentFilter)
          this.prev = currentFilter
        }
      })
    })
  }

  articleFilter(filter, articles) {
    articles.forEach(el => {
      const match = filter === "all" || el.dataset.filter === filter
      el.classList.toggle("article-grid__article--hidden", !match)
    })
  }

  updateSelected(filterItems, selectedFilter) {
    filterItems.forEach(item => {
      item.classList.toggle(
        "article-grid__filter--selected-filter",
        item.dataset.filter === selectedFilter
      )
    })
  }
}

export default FilterHandler
